module.exports = __webpack_public_path__ + "static/media/chat-background.38ef6a56.png";